<template>
    <div class="box" v-if="step == stepNum">
        <h2>{{ stepNum }}</h2>
        <h3 class="step-name">{{ stepName || 'Unnamed Step' }}</h3>

        <div class="spacer"></div>
        <slot name="active"></slot>
        <div class="spacer"></div>
        <button class="button" @click="$emit('continue')">Continue</button>
    </div>
    <div class="box" v-else-if="step > stepNum">
        <a class="is-pulled-right clickable" @click="$emit('edit')">Edit</a>

        <h2 class="past-step">{{ stepNum }}</h2>
        <h3 class="step-name">{{ stepName || 'Unnamed Step' }}</h3>

        <div class="spacer"></div>
        <div class="finished">
            <slot name="finished"></slot>
        </div>
    </div>
    <div class="box" v-else>
        <h2>{{ stepNum }}</h2>
        <h3 class="step-name">{{ stepName || 'Unnamed Step' }}</h3>
    </div>
</template>

<script>
export default {
  name: 'checkout-step',

  props: ['step-num', 'step', 'step-name'],
};
</script>

<style scoped>
.past-step {
  opacity: 0.5;
}
.box h3,
.box h2 {
  display: inline;
}
.step-name {
  margin-left: 0.5em;
}

.spacer {
  margin: 1em;
}

.clickable {
  cursor: pointer;
}
.finished {
  font-size: 20px !important;
  font-family: 'Cormorant';
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckoutStep.vue